<template>
  <div>
    <el-row>
      <el-col v-if="isShowOne" style="text-align: left;font-size: 16px;" :span="20">
      <el-row>
        <el-col style="text-indent: 40px;" :span="22" :offset="1">
          <span style="font-weight: bold">标准号：</span>
          {{data.standardNumber}}</el-col>
      </el-row>
      <el-row >
        <el-col style="text-indent: 40px;" :span="22" :offset="1">
          <span style="font-weight: bold">中文名称：</span>
        {{data.name}}</el-col>
      </el-row>
      <el-row >
        <el-col style="text-indent: 40px;" :span="22" :offset="1">
          <span style="font-weight: bold">英文名称：</span>
        {{data.englishName}}</el-col>
      </el-row>
      <el-row >
        <el-col style="text-indent: 40px;" :span="22" :offset="1">
          <span style="font-weight: bold">发布日期：</span>
        {{data.dateOfIssue}}</el-col>
      </el-row>
      <el-row >
        <el-col style="text-indent: 40px;" :span="22" :offset="1">
          <span style="font-weight: bold">发布单位：</span>
        {{data.publishingUnit}}</el-col>
      </el-row>
      <el-row >
        <el-col style="text-indent: 40px;" :span="22" :offset="1">
          <span style="font-weight: bold">实施日期：</span>
        {{data.implementationDate}}</el-col>
      </el-row>
       <el-row >
        <el-col style="text-indent: 40px;" :span="22" :offset="1">
          <span style="font-weight: bold">废止日期：</span>
        {{data.a206}}</el-col>
      </el-row>
    </el-col>

      <div v-if="!isShowOne" style="text-align: left;font-size: 16px;">
        <el-row>
          <el-col style="text-indent: 40px" :span="22" :offset="1">
            <span style="font-weight: bold">标准号：</span>{{data.a100}}
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col style="text-indent: 40px" :span="22" :offset="1">
            <span style="font-weight: bold">中文名称：</span>{{data.a298}}
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col style="text-indent: 40px" :span="22" :offset="1">
            <span style="font-weight: bold">英文名称：</span>{{data.a302}}
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col style="text-indent: 40px" :span="22" :offset="1">
            <span style="font-weight: bold">发布日期：</span>{{data.a101}}
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col style="text-indent: 40px" :span="22" :offset="1">
            <span style="font-weight: bold">发布单位：</span>{{data.a209}}
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col style="text-indent: 40px" :span="22" :offset="1">
            <span style="font-weight: bold">实施日期：</span>{{data.a205}}
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col style="text-indent: 40px" :span="22" :offset="1">
            <span style="font-weight: bold">废止日期：</span>{{data.a206}}
          </el-col>
        </el-row>
      </div>
    </el-row>
  </div>
</template>
<script>
import request from "../../../utils/request";

export default {
  name:'standardDetail',
  props:{
    id:{
      type:String,
      required:true
    }
  },
  data(){
    return{
      data:{},
      isShowOne:false,
      isShowTow:false,
    }
  },
  methods:{
    getData(){
      request({
        url:'portalController/getStandard',
        methods: 'get',
        params:{
          id:this.id
        }
      }).then(rsp=>{
        if(rsp.resultCode=='0'){
          this.data=rsp.data
          console.log('data',this.data)
          if (this.data.name) {
            this.isShowOne=true;
            console.log(this.isShowOne)
          } else {
            this.isShowTow=true;
          }
        }else {
          this.$message({
            message:'标准查看详情错误',
            type:'error',
            duration:1500
          })
        }
      })
    }
  },
  mounted(){
    this.getData();
  }
}
</script>
<style scoped>
.el-divider--horizontal{
  margin:10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/compoment/standardDetail.vue